import {useTheme} from '@material-ui/core/styles';
import {UeTheme} from '../ueTheme.types';
import {Breakpoint, Breakpoints} from '@material-ui/core/styles/createBreakpoints';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const useBreakpoints = (): Breakpoints => {
    const theme: UeTheme = useTheme();
    return theme.breakpoints;
};

export const useBreakpointQuery = (query: string | ((theme: UeTheme) => string)): boolean => {
    return useMediaQuery(query);
};

export const useBreakpointDown = (width: Breakpoint): boolean => {
    const breakpoints = useBreakpoints();
    return useBreakpointQuery(breakpoints.down(width));
};

export const useBreakpointUp = (width: Breakpoint): boolean => {
    const breakpoints = useBreakpoints();
    return useBreakpointQuery(breakpoints.up(width));
};

export const useBreakpointOnly = (width: Breakpoint): boolean => {
    const breakpoints = useBreakpoints();
    return useBreakpointQuery(breakpoints.only(width));
};
